import { useCallback, useState } from 'react'
import { unique } from 'lib/array/arrayUtils'
import { useEventSubscription } from 'tripPlanner/assistant/contexts/TripPlannerEventBus'
import { useChatOperationScope } from './useChatOperationScope'

const NO_BOOKING_ITEM_IDS: ReadonlyArray<string> = []

/** Marks the items once `send` resolves, unless the chat was reset or left meanwhile. */
export type AddBookingItems = (send: () => Promise<void>, bookingItemIds: ReadonlyArray<string>) => Promise<void>

/** Booking items already sent into the current chat, so Add a booking can't offer them twice. */
export function useAddedBookingItemIds(isLoggedIn: boolean) {
  const [addedBookingItemIds, setAddedBookingItemIds] = useState(NO_BOOKING_ITEM_IDS)
  // Not scoped to the chat id: a first send creates the chat, and its items belong to it.
  const captureScope = useChatOperationScope(undefined, isLoggedIn)

  const clear = useCallback(() => {
    setAddedBookingItemIds(NO_BOOKING_ITEM_IDS)
  }, [])
  useEventSubscription('reset_chat_state', clear)

  const addBookingItems = useCallback<AddBookingItems>(async(send, bookingItemIds) => {
    const isCurrent = captureScope()
    await send()
    if (isCurrent()) {
      setAddedBookingItemIds(previous => unique([...previous, ...bookingItemIds]))
    }
  }, [captureScope])

  return { addedBookingItemIds, addBookingItems }
}
